import Rollbar from "rollbar";
import ToastEventBus from 'primevue/toasteventbus';
import store from '../store';
import {watch} from 'vue';

const enabled = Boolean(process.env.MIX_ROLLBAR_ACCESS_KEY);

const rollbar = new Rollbar({
  accessToken: process.env.MIX_ROLLBAR_ACCESS_KEY,
  captureUncaught: true,
  captureUnhandledRejections: true,
  enabled: enabled,
});

watch(() => store.getters['auth/user'], (user = {}) => {
  rollbar.configure({
    payload: {
      person: {
        id: user.id,
        email: user.email,
      }
    }
  });
})

export const logError = (error, additionalErrorData = {}) => {
  const message = error instanceof Error ? error.message : error;

  ToastEventBus.emit('add', {severity: 'error', summary: 'Error Message', detail: message, life: 5000});

  rollbar.error(error, additionalErrorData);
  console.error(error);
}
